<template>
  <div class="mb-12" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-8' : 'px-3'">
     <v-dialog
      v-model="dialog.publish"
      persistent
      width="450">
      <v-card class="pa-4">
        <v-card-text class="body-2 pt-3 pb-5">
          Apakah Anda yakin untuk 
          <span v-if="detail.libraryStatus !== 'publish'">mengaktifkan</span> 
          <span v-if="detail.libraryStatus === 'publish'">menonaktifkan</span> kelas ini ?
        </v-card-text>
        <div class="text-center">
          <v-alert 
            type="error" 
            text
            dense
            prominent
            v-show="response !== ''">
            {{ response }}
          </v-alert>
        </div>
        <v-card-actions class="pb-4">
          <v-spacer></v-spacer>
          <v-btn
            rounded
            small
            width="120"
            color="#ff618a"
            elevation="0"
            :disabled="process.create"
            :loading="process.create"
            class="white--text text-capitalize"
            @click="toPublish">
            <span v-if="detail.libraryStatus !== 'publish'">Aktifkan</span> 
            <span v-if="detail.libraryStatus === 'publish'">Non-aktifkan</span>
          </v-btn>
          <v-btn
            rounded
            small
            width="120"
            elevation="0"
            class="text-capitalize"
            :disabled="process.create"
            @click="dialog.publish = false; response = ''">
            Tidak
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.file" persistent
      width="650">
      <v-card class="pa-5">
        <div class="headline font-weight-bold">
          {{ detail.libraryTitle }}
        </div>
        <video
          id="myVideo"
          width="100%" 
          height="400px" 
          :src="detail.libraryUrlFile" 
          :poster="detail.libraryUrlCover" 
          playsinline 
          controls
          v-if="detail.libraryFormat === 'video'">
        </video>
        <iframe 
          width="100%" 
          height="405" 
          :src="detail.libraryUrlFile" 
          frameborder="0" 
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
          allowfullscreen
          v-if="detail.libraryFormat === 'pdf'">
        </iframe>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            rounded
            width="100"
            elevation="0"
            class="text-capitalize mt-5 mb-0"
            @click="dialog.file = false; stop()">
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-breadcrumbs 
      :items="breadcrumbs" 
      divider=">"
      class="pa-1">
    </v-breadcrumbs>
    <div> 
      <v-row justify="center" v-if="process.run">
        <v-col :cols="$vuetify.breakpoint.name === 'xs' ? '6' : '3' ">
          <div
            class="text-center" 
            style="padding-top: 12rem; padding-bottom: 12rem; height:535px;">
            <p class="title mt-8 mb-5 pink--text">
              Menunggu data . . .
            </p>
            <v-progress-linear
              color="#ff618a"
              indeterminate
              rounded
              height="6">
            </v-progress-linear>
          </div>
        </v-col>
      </v-row>
      <v-row class="align-start" v-if="!process.run && Object.keys(detail).length > 0">
        <v-col cols="12" sm="4">
          <v-card color="#fff" class="pa-2">
            <v-img
              :src="detail.libraryUrlCover"
              gradient= "to top, rgba(0, 0, 0, 0.50), rgba(0, 0, 0, 0.50)"
              width="100%"
              :height="$vuetify.breakpoint.name === 'xs' ? '200' : '200'" 
              class="align-center text-center cursor-pointer"
              @click="dialog.file = true">
              <p class="mb-0">
                <img v-if="detail.libraryFormat === 'video'" height="50px" :src="require('../../../assets/icon/play-round.png')">
              </p>
            </v-img>
              <div class="py-5 px-2">
                <div class="headline font-weight-bold" v-if="detail.libraryDiscount > 0">
                  {{
                    detail.libraryPrice - ((detail.libraryPrice / 100) * detail.libraryDiscount) | price
                  }}
                  <sup>
                    <v-avatar color="red" size="28">
                      <small class="white--text font-weight-bold" style="font-size: 10px"> 
                        {{ detail.libraryDiscount }}%
                      </small>
                    </v-avatar>
                  </sup>
                </div>
                <div class="subtitle-2 font-weight-bold red--text" style="text-decoration: line-through;"
                  v-if="detail.libraryDiscount > 0">
                  {{ detail.libraryPrice | price }}
                </div>
                <div class="headline font-weight-bold" v-if="detail.libraryDiscount < 1">
                  <span v-if="detail.libraryPrice > 0">
                    {{ detail.libraryPrice | price }}
                  </span>
                  <span v-else>
                    Gratis
                  </span>
                </div>
                <div class="mt-5">
                  <v-btn
                    rounded
                    block
                    color="#FF618A"
                    class="text-capitalize mt-1 white--text font-weight-bold"
                    @click="dialog.publish = true">
                    <b v-if="detail.libraryStatus === 'draft'">Aktifkan Materi</b>
                    <b v-if="detail.libraryStatus === 'publish'">Non-Aktifkan Materi</b>
                  </v-btn>
                </div>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="8">
          <div class="d-flex align-center">
            <div class="headline font-weight-bold">
              {{ detail.libraryTitle }}
            </div>
            <div class="text-right ml-auto">
              <div>
                <v-btn 
                  small
                  text
                  rounded
                  color="#269B91"
                  class="text-capitalize ma-1"
                  :to="`/library/general?id=${$route.params.id}`">
                  <v-icon small class="mr-2">mdi-square-edit-outline</v-icon> Ubah Materi
                </v-btn>
              </div>
            </div>
          </div>
          <div class="text--secondary">
            Dibuat oleh {{ detail.libraryUserName }}
          </div>
          <div class="mt-3 caption d-flex">
            <v-icon small class="mt-1">mdi-calendar</v-icon>
            <div class="pt-2 ml-2">
              Tanggal Pembuatan: {{ detail.libraryDateCreated | date }}
            </div>
          </div>
          <div class="caption d-flex">
            <v-icon small class="mt-1">mdi-clock-time-four-outline</v-icon>
            <div class="pt-2 ml-2">
              Durasi: {{ detail.libraryDuration * 60000 | millis }}
            </div>
          </div>
          <div v-if="detail.libraryDesc.length > 1200">
            <div class="body-2"
              v-if="!showDesc">
              <span v-html="descShort"></span>
              <div class="font-weight-bold text--secondary caption cursor-pointer" @click="showDesc = true">
                lihat selengkapnya
                <v-icon small>mdi-chevron-down</v-icon>
              </div>
            </div>
            <div 
              class="body-2"
              v-if="showDesc">
              <span v-html="detail.libraryDesc"></span>
              <div class="font-weight-bold text--secondary caption cursor-pointer" @click="showDesc = false">
                tutup
                <v-icon small>mdi-chevron-up</v-icon>
              </div>
            </div>
          </div>
          <div class="my-5" v-html="detail.libraryDesc" v-if="detail.libraryDesc.length <= 1200"></div>
          <v-divider/>
          <div>
            <div class="body-2 font-weight-bold mt-3">
              Kelas yang menggunakan materi ini
            </div>
            <v-skeleton-loader
              class="ma-auto"
              :loading="process.class"
              transition="scale-transition"
              type="list-item-avatar-two-line"
              v-for="(l, index) in process.class ? 10:list"
              :key="index">
              <v-list dense class="line my-3" :class="$vuetify.breakpoint.name === 'xs' ? 'mr-0' : 'mr-5'">
                <v-list-item
                  :to="`/class/${l.id}`">
                  <v-list-item-avatar tile class="cursor-pointer" style="box-shadow: 0px 5px 10px -5px rgba(0, 0, 0, 0.3) !important;">
                    <img :src="l.classesUrlCover" style="border-radius: 5px;">
                  </v-list-item-avatar>
                  <v-list-item-content class="cursor-pointer">
                    <v-list-item-title class="body-2 font-weight-bold grey--text text--darken-2">
                      {{ l.classesTitle }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="caption mt-1 font-weight-thin">
                      Judul Kelas
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-skeleton-loader>
            <Empty v-show="!process.class && list.length < 1" content="Data Kelas"/>
            <div v-if="paginationClass.totalPage > 1">
              <v-row>
                <v-col cols="5">
                  <div class="body-2	font-weight-bold mt-4">
                    Total {{ paginationClass.totalData }} data
                  </div>
                </v-col>
                <v-col cols="7">
                  <div class="float-right">
                    <v-pagination
                      v-model="page"
                      :length="paginationClass.totalPage"
                      :total-visible="5"
                      color="#FF618A"
                      @input="fetchClass(page)"
                      circle>
                    </v-pagination>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../service/Axios";
  import Empty from "../../../components/DataEmpty"; 
  export default {
    data () {
      return {
        breadcrumbs: [                                             
          {
            text: 'Materi',
            disabled: false,
            href: '/library',
          },
          {
            text: 'Detail Materi',
            disabled: true,
            href: '#',
          }
        ],
        dialog: {
          publish: false,
          file: false
        },
        showDesc: false,
        descShort: '',
        detail: {},
        list: [],
        paginationClass: {},
        page: 1,
        process: {
          run: false,
          class: false
        },
        response: ''
      }
    },
    components: {
      Empty 
    },
    mounted() {
      this.fetch()
      this.fetchClass()
    },
    methods: { 
      async fetch() {
        // if (p === undefined) {
        //   this.page = 1
        // }
        this.process.run = true
        await get(`api/internal/library/detail/${this.$route.params.id}`)
        .then((response) => {
          let res = response.data
          if (res.code === 200) {
            this.process.run = false
            this.detail = res.data
            this.detail.libraryDesc = this.detail.libraryDesc.replace(/&lt;/g, '<')
            if (this.detail.libraryDesc.length > 350) {
              this.descShort = this.detail.libraryDesc.substring(0, 1200) + " . . ."
            } else {
              this.descShort = this.detail.libraryDesc
            }
          }
        })
      },
      async toPublish(){
         this.process.create = true
         await put(`api/internal/library/update/status/${this.detail.id}`,{
           data:{
             libraryStatus : this.detail.libraryStatus === 'publish' ? 'draft':'publish'
           }
         })
         .then((response) => {
          if (response.data.code === 201) {
            this.dialog.publish = false
            this.fetch()
          } else {
            this.response = response.data.msg
          }
          this.process.create = false
        })
      },
      async fetchClass(p) {
        this.process.class = true
        await get(`api/internal/class`, {
          params: {
            pagenum: p,
            limit: 10,
            materiId: this.$route.params.id
          }
        })
        .then((response) => {
          let res = response.data
          if (res.code === 200) {
            this.list = res.data
            this.paginationClass = res.pagination
            this.process.class = false
          }
        })
      },
      stop() {
        let vid = document.getElementById("myVideo")
        vid.pause()
      }
    }
  }
</script>

<style scoped>
.card-img {
    width: 350px;
    margin-left: auto;
    margin-top: -200px;
  }
</style>